import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { loadQuestionsByCatalog } from '../../services/questionAPIService';
import { createUserQuestionHistory } from '../../services/statAPIService';
import StandardLayout from '../../components/layout/StandardLayout';
import QuizEngine from '../../components/quiz/QuizEngine';

const MicroLearningQuiz = () => {
  const { catalogId } = useParams();
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadQuestions = async () => {
      try {
        setIsLoading(true);
        const response = await loadQuestionsByCatalog(catalogId);
        
        if (!response || response.length === 0) {
          console.log("No questions received from the backend");
          return;
        }

        setQuestions(response);
      } catch (error) {
        console.error("Error loading questions:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadQuestions();
  }, [catalogId]);

  const handleComplete = async (completedQuestions) => {
    try {
      await createUserQuestionHistory(completedQuestions);
      navigate('/micro-learning');
    } catch (error) {
      console.error("Error completing quiz:", error);
    }
  };

  return (
    <StandardLayout>
      <div className="container mx-auto px-4 py-8 max-w-5xl">
        {isLoading ? (
          <div className="text-center">
            <span className="loading loading-spinner loading-lg"></span>
            <p className="mt-2">Loading questions...</p>
          </div>
        ) : (
          questions.length > 0 && <QuizEngine questions={questions} onComplete={handleComplete} />
        )}
      </div>
    </StandardLayout>
  );
};

export default MicroLearningQuiz; 